import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { CandidateCountersHttpClient } from './candidate-counters-http-client';
import { CandidateCountersActions } from './candidate-counters.store';

@Injectable({ providedIn: 'root' })
export class CandidateCountersEffects {
  public effect = createEffectFactory(CandidateCountersActions, this.actions$);

  private fetch$ = this.effect(CandidateCountersActions.fetch, () =>
    this.candidateCountersHttpClient.loadCounters(),
  );

  constructor(
    private actions$: Actions,
    private candidateCountersHttpClient: CandidateCountersHttpClient,
  ) {}
}
